import { useRef, useState } from 'react';
import { toast } from 'sonner';
import { Images, Loader2 } from 'lucide-react';
import { uploadFiles } from '@/lib/upload';

export default function BulkUploadButton({ category = 'gallery', onDone, label = 'Bulk upload photos', testid = 'bulk-upload-btn', className = '' }) {
  const ref = useRef(null);
  const [prog, setProg] = useState(null);

  const handle = async (e) => {
    const files = e.target.files;
    if (!files?.length) return;
    setProg([0, files.length]);
    const urls = await uploadFiles(files, category, (d, t) => setProg([d, t]));
    setProg(null);
    if (ref.current) ref.current.value = '';
    if (!urls.length) { toast.error('No photos uploaded'); return; }
    await onDone(urls);
    toast.success(`${urls.length} photo${urls.length > 1 ? 's' : ''} added`);
  };

  return (
    <>
      <button type="button" disabled={!!prog} onClick={() => ref.current?.click()} data-testid={testid}
        className={`inline-flex items-center gap-1.5 text-sm px-4 py-2 rounded-full bg-gold text-royal-dark font-semibold hover:brightness-95 disabled:opacity-60 ${className}`}>
        {prog ? <Loader2 className="w-4 h-4 animate-spin" /> : <Images className="w-4 h-4" />}
        {prog ? `Uploading ${prog[0]}/${prog[1]}…` : label}
      </button>
      <input ref={ref} type="file" accept="image/*" multiple className="hidden" onChange={handle} data-testid={`${testid}-input`} />
    </>
  );
}
